var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12C1 5.92487 5.92487 1 12 1H28C34.0751 1 39 5.92487 39 12V28C39 34.0751 34.0751 39 28 39H12C5.92487 39 1 34.0751 1 28V12Z",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_201_267",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 10,
    width: 21,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0625 10.4277H9.91693V29.5733H29.0625V10.4277Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_201_267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8573 29.5733V21.0641H23.5923L24.2761 17.5187H20.8573V16.1005C20.8573 14.6823 21.5424 13.9732 22.9086 13.9732H24.2761V10.4277C23.5923 10.4277 22.7445 10.4277 21.541 10.4277C19.0282 10.4277 17.4384 12.4706 17.4384 15.3914V17.5187H14.7033V21.0641H17.4384V29.5733H20.8573Z",
    fill: "white",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.a29aaa6c660d6e5ed8f3ce70260d8abe.svg";
export { ForwardRef as ReactComponent };